import api from "../../services/api";
import {
  ADD_COURSE_TO_CART_FAILURE,
  ADD_COURSE_TO_CART_REQUEST,
  ADD_COURSE_TO_CART_SUCCESS,
  DELETE_COURSE_FROM_CART_FAILURE,
  DELETE_COURSE_FROM_CART_REQUEST,
  DELETE_COURSE_FROM_CART_SUCCESS,
  GET_CART_DETAIL_FAILURE,
  GET_CART_DETAIL_REQUEST,
  GET_CART_DETAIL_SUCCESS,
  GET_COURSES_FROM_CART_FAILURE,
  GET_COURSES_FROM_CART_REQUEST,
  GET_COURSES_FROM_CART_SUCCESS,
  RESET_ADD_COURSE_TO_CART,
  RESET_REMOVE_COURSE_FROM_CART,
} from "./ActionType";

const addCourseToCartRequest = () => {
  return {
    type: ADD_COURSE_TO_CART_REQUEST,
  };
};

const addCourseToCartSuccess = (course) => {
  return {
    type: ADD_COURSE_TO_CART_SUCCESS,
    payload: course,
  };
};

const addCourseToCartFailure = (error) => {
  return {
    type: ADD_COURSE_TO_CART_FAILURE,
    payload: error,
  };
};

export const addCourseToCart = (courseId) => async (dispatch) => {
  dispatch(addCourseToCartRequest());
  try {
    const response = await api.post("/cart/courses", { courseId: courseId });
    const course = response.data;
    dispatch(addCourseToCartSuccess(course));
  } catch (error) {
    dispatch(addCourseToCartFailure(error.message));
  }
};

const getCartDetailRequest = () => {
  return {
    type: GET_CART_DETAIL_REQUEST,
  };
};

const getCartDetailSuccess = (cart) => {
  return {
    type: GET_CART_DETAIL_SUCCESS,
    payload: cart,
  };
};

const getCartDetailFailure = (error) => {
  return {
    type: GET_CART_DETAIL_FAILURE,
    payload: error,
  };
};

export const getCartDetail = () => async (dispatch) => {
  dispatch(getCartDetailRequest());
  try {
    const response = await api.get("/cart");
    const cart = response.data;
    dispatch(getCartDetailSuccess(cart));
  } catch (error) {
    dispatch(getCartDetailFailure(error.response.data));
  }
};

const deleteCourseFromCartRequest = () => {
  return {
    type: DELETE_COURSE_FROM_CART_REQUEST,
  };
};

const deleteCourseFromCartSuccess = (courseId) => {
  return {
    type: DELETE_COURSE_FROM_CART_SUCCESS,
    payload: courseId,
  };
};

const deleteCourseFromCartFailure = (error) => {
  return {
    type: DELETE_COURSE_FROM_CART_FAILURE,
    payload: error,
  };
};

export const removeCourseFromCart = (courseId) => async (dispatch) => {
  dispatch(deleteCourseFromCartRequest());
  try {
    const response = await api.delete(`/cart/courses/${courseId}`);
    dispatch(deleteCourseFromCartSuccess(response));
  } catch (error) {
    dispatch(deleteCourseFromCartFailure(error.message));
  }
};

export const resetAddCourseToCart = () => {
  return {
    type: RESET_ADD_COURSE_TO_CART,
  };
};

export const resetRemoveCourseFromCart = () => {
  return {
    type: RESET_REMOVE_COURSE_FROM_CART,
  };
};

const getCoursesFromCartRequest = () => {
  return {
    type: GET_COURSES_FROM_CART_REQUEST,
  };
};

const getCoursesFromCartSuccess = (courses) => {
  return {
    type: GET_COURSES_FROM_CART_SUCCESS,
    payload: courses,
  };
};

const getCoursesFromCartFailure = (error) => {
  return {
    type: GET_COURSES_FROM_CART_FAILURE,
    payload: error,
  };
};

export const getCoursesFromCart = () => async (dispatch) => {
  dispatch(getCoursesFromCartRequest());
  try {
    const response = await api.get("/cart/courses");
    // Extract the actual courseIds array from the response
    const courseIds = response.data?.data || response.data || [];
    dispatch(getCoursesFromCartSuccess(courseIds));
  } catch (error) {
    dispatch(getCoursesFromCartFailure(error.message));
  }
};
